<div class="generic-modal row">
  <div class="col-12 auto-center">
    @if (!isHttpError) {
      <p class="info-text modal-text text-center">
        {{ 'logout_error_expired_session' | translate }}
      </p>
      <img class="img-alert" src="assets/img/icono_crono.png" alt="Sesión expirada" />
    } @else {
      <img class="img-alert" src="assets/img/ko.png" alt="imagen de error" />
      <p class="info-text modal-text text-center">{{ 'logout_error_generic' | translate }}</p>
    }
  </div>

  <button class="btn btn-02 btn-modal" type="submit" (click)="accept()" id="btn-accept">
    {{ 'logout_btn_modal' | translate }}
  </button>
</div>
